import React, { useEffect, useState } from "react";
import { Grid, Box, Typography, Avatar, Checkbox } from "@mui/material";
import CustomModal from "../../CustomModal/CustomModal";
import ModalFooter from "../../CustomModal/ModalFooter";
import ModalHeader from "../../CustomModal/ModalHeader";
import SearchComponent from "../../../components/SearchComponent";
import CustomTextField from "../../../components/CustomTextField/CustomTextField";
import CustomDatePicker from "../../../components/CustomDatePicker/CustomDatePicker";
import CustomAutoComplete from "../../../components/CustomAutoComplete/CustomAutoComplete";

import CompDirection from "../../../themes/CompDirection";
import { fonts } from "../../../themes/themes";
interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;

  trans?: any;
}

const CreateBoardModalPresenter = ({
  isModalOpen,
  closeModal,

  trans,
}: ModalProps) => {
  return (
    <CustomModal isModalOpen={isModalOpen} modalHeight="75vh" modalWidth="15vw">
      <ModalHeader
        modal={{ modal_title: trans("Create Board") }}
        closeModal={closeModal}
      />
      <CompDirection>
        <Grid
          spacing={2}
          container
          sx={{
            marginTop: "15px",
          }}
        >
          <Grid item xs={12}>
            <CustomTextField type="string" label="Board Title" />
          </Grid>
        </Grid>
      </CompDirection>

      <Box style={{ marginTop: "35px" }} />
      <ModalFooter
        onClickCancel={() => {
          closeModal();
        }}
      />
    </CustomModal>
  );
};

export default CreateBoardModalPresenter;
